import ReportDownloadFilter from './SelectionFiltersModel'
function MySavedFilter() {
    return {
        id: null,
        name: null,
        selectionFilters: ReportDownloadFilter()
      }
}
export default MySavedFilter;